import React from 'react';
import Responsive from 'react-responsive';

const mobile = 759;
const desktop = 991;
const defaultQuery = `print, screen and (min-width: ${mobile + 1}px)`;
const mobileQuery = `screen and (max-width: ${mobile}px)`;

const Desktop = props => <Responsive {...props} minWidth={desktop + 1} />;
const Tablet = props => <Responsive {...props} minWidth={mobile + 1} maxWidth={desktop} />;
const Mobile = props => <Responsive {...props} query={mobileQuery} />;
const Default = props => <Responsive {...props} query={defaultQuery} />;

export { Default, Mobile };



// WEBPACK FOOTER //
// ./src/responsive.js